import React from "react"
import BookingButtonPresenterGeneral from "./tabs/BookingButtonPresenterGeneral"
import BookingButtonPresenterSessionTimeout from "./tabs/BookingButtonPresenterSessionTimeout"
import BookingButtonPresenterMenu from "./tabs/BookingButtonPresenterMenu"
import BookingButtonPresenterForm from "./tabs/BookingButtonPresenterForm"
import BookingButtonPresenterRoomTypeOrder from "./tabs/BookingButtonPresenterRoomTypeOrder"
import BookingButtonPresenterNoAvailability from "./tabs/BookingButtonPresenterNoAvailability"
import BookingButtonPresenterInstallation from "./tabs/BookingButtonPresenterInstallation"
import BookingButtonPresenterHistory from "./tabs/BookingButtonPresenterHistory"

class BookingButtonPresenterTabContent extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    if(this.props.revert == true) {
      return (
        <div className="tab-content">
           <BookingButtonPresenterGeneral {...this.props} />
        </div>
      )
    }

    return (
      <div className="tab-content">
        <BookingButtonPresenterGeneral {...this.props} />
        <BookingButtonPresenterSessionTimeout {...this.props} />
        <BookingButtonPresenterMenu {...this.props} />
        <BookingButtonPresenterForm {...this.props} />
        <BookingButtonPresenterRoomTypeOrder {...this.props} />
        <BookingButtonPresenterNoAvailability {...this.props} />
        <BookingButtonPresenterInstallation {...this.props} />
        <BookingButtonPresenterHistory {...this.props} />
      </div>
    )
  }

};

export default BookingButtonPresenterTabContent